import {
    POST_DETAILS_FOR_DELIVERY_SCHEDULE, UPDATE_DELIVERY_SCHEDULE_DETAILS, GET_COMMENTS_FOR_POS, GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER,
    GET_DOCUMENTS_FOR_EXPEDITING,
    GET_DOCUMENT_DETAILS_FOR_EXPEDITING,
    POST_DOCUMENT_DETAILS_FOR_EXPEDITING,
    GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING,
    GET_NEXT_ACTION_ROLE_FOR_APPROVAL, GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM,
    GET_EXPEDITING_DOCUMENT_WITH_DETAILS,
    GET_ASSIGNED_ENGINEER_DETAILS,
    UPDATE_ENGINEER_ASSIGNMENT_DETAILS,
    GET_NEXT_ACTED_USERID,
    GET_DRAWINGS_FOR_EXPEDITING,
    POST_DRAWING_DOCUMENT_DETAILS,
    GET_DRAWING_ACTION_DETAILS,
    POST_ASSIGNED_ENGINEER_DETAILS,
    GET_ALL_ASSIGNED_ENGINEER_DETAILS,
    POST_MANUFACTURING_CLEARENCE_DETAILS,
    GET_MANUFACTURING_CLEARENCE_DETAILS,
    GET_CLAIM_DETAILS_FOR_EXPEDITING,
    GET_PO_TANSMITTLE_DOCUMENT_DETAILS,
    GET_PROGRESS_REPORT_DOCUMENT_DETAILS,
    GET_ALL_LINE_ITEMS_SP_CASE,
    GET_ALL_DOCUMENTS_FROM_QA,
    GET_BG_DETAILS,
    BG_UPLOAD,
    BG_UPLOAD_ERROR,
    BG_STATUS_UPDATE,
    BG_STATUS_UPDATE_ERROR,
    BG_Request_ACTION,
    BG_Request_ACTION_ERROR,
} from '../type'

const initialState = {
    deliveryScheduledetails: [],
    commentsForPOs: [],
    updatedsdetails: [],
    accepteddeliveryScheduledetails: [],
    expeditingDocuments: [],
    expeditingDocumentDetails: [],
    expDocumentDetails: [],
    expDocumentApprovalDetails: [],
    nextActedTeam: [],
    getExpeditingStatusId: [],
    getExpeditingDocumentsWithDetails: [],
    getAssignedEngineerDetails: [],
    updatedengineerassignmentdetails: [],
    getNextActedUserId: [],
    expeditingDrawingDocuments: [],
    postDrawingDocumentDetails: [],
    getDrawingActionDetails: [],
    getAllAssignedEngineerDetails: [],
    postAssignedEngineerDetails: [],
    getManufacturingDetails: [],
    postManufacturingDetails: [],
    getClaimDetailsByPoId: [],
    getPoTransmittleDOcuments: [],
    getProgressReport: [],
    getAllPoLineItems: [],
    getDocumentsfromQA: [],
    bgDetails: [],
    bgUpload: null,
    bgStatusupdate: null,
    bgRequestacton: []
}
export default function expeditingReducer(state = initialState, action) {
    switch (action.type) {

        case POST_DETAILS_FOR_DELIVERY_SCHEDULE:
            return {
                ...state,
                deliveryScheduledetails: action.payload,
                loading: false

            }
        case GET_COMMENTS_FOR_POS:
            return {
                ...state,
                commentsForPOs: action.payload,
                loading: false

            }
        case UPDATE_DELIVERY_SCHEDULE_DETAILS:
            return {
                ...state,
                updatedsdetails: action.payload,
                loading: false
            }
        case GET_ALL_ACCEPTED_DELIVERY_SCHEDULE_DETAIL_FOR_SUPPLIER:
            return {
                ...state,
                accepteddeliveryScheduledetails: action.payload,
                loading: false
            }
        case GET_DOCUMENTS_FOR_EXPEDITING:
            return {
                ...state,
                expeditingDocuments: action.payload,
                loading: false
            }
        case GET_DOCUMENT_DETAILS_FOR_EXPEDITING:
            return {
                ...state,
                expeditingDocumentDetails: action.payload,
                loading: false
            }
        case POST_DOCUMENT_DETAILS_FOR_EXPEDITING:
            return {
                ...state,
                expDocumentDetails: action.payload,
                loading: false
            }
        case GET_DOCUMET_APPROVAL_DETAILS_FOR_EXPEDITING:
            return {
                ...state,
                expDocumentApprovalDetails: action.payload,
                loading: false
            }
        case GET_NEXT_ACTION_ROLE_FOR_APPROVAL:
            return {
                ...state,
                nextActedTeam: action.payload,
                loading: false
            }

        case GET_EXPEDITING_STATUS_ID_FOR_POLINEITEM:
            return {
                ...state,
                getExpeditingStatusId: action.payload,
                loading: false
            }

        case GET_EXPEDITING_DOCUMENT_WITH_DETAILS:
            return {
                ...state,
                getExpeditingDocumentsWithDetails: action.payload,
                loading: false
            }

        case GET_ASSIGNED_ENGINEER_DETAILS:
            return {
                ...state,
                getAssignedEngineerDetails: action.payload,
                loading: false

            }

        case UPDATE_ENGINEER_ASSIGNMENT_DETAILS:
            return {
                ...state,
                updatedengineerassignmentdetails: action.payload,
                loading: false

            }
        case GET_NEXT_ACTED_USERID:
            return {
                ...state,
                getNextActedUserId: action.payload,
                loading: false
            }
        case GET_DRAWINGS_FOR_EXPEDITING:
            return {
                ...state,
                expeditingDrawingDocuments: action.payload,
                loading: false
            }
        case POST_DRAWING_DOCUMENT_DETAILS:
            return {
                ...state,
                postDrawingDocumentDetails: action.payload,
                loading: false
            }
        case GET_DRAWING_ACTION_DETAILS:
            return {
                ...state,
                getDrawingActionDetails: action.payload,
                loading: false
            }

        case GET_ALL_ASSIGNED_ENGINEER_DETAILS:
            return {
                ...state,
                getAllAssignedEngineerDetails: action.payload,
                loading: false
            }
        case POST_ASSIGNED_ENGINEER_DETAILS:
            return {
                ...state,
                postAssignedEngineerDetails: action.payload,
                loading: false
            }
        case POST_MANUFACTURING_CLEARENCE_DETAILS:
            return {
                ...state,
                postManufacturingDetails: action.payload,
                loading: false
            }
        case GET_MANUFACTURING_CLEARENCE_DETAILS:
            return {
                ...state,
                getManufacturingDetails: action.payload,
                loading: false
            }
        case GET_CLAIM_DETAILS_FOR_EXPEDITING:
            return {
                ...state,
                getClaimDetailsByPoId: action.payload,
                loading: false
            }
        case GET_PO_TANSMITTLE_DOCUMENT_DETAILS:
            return {
                ...state,
                getPoTransmittleDOcuments: action.payload,
                loading: false
            }
        case GET_PROGRESS_REPORT_DOCUMENT_DETAILS:
            return {
                ...state,
                getProgressReport: action.payload,
                loading: false
            }
        case GET_ALL_LINE_ITEMS_SP_CASE:
            return {
                ...state,
                getAllPoLineItems: action.payload,
                loading: false
            }
        case GET_ALL_DOCUMENTS_FROM_QA:
            return {
                ...state,
                getDocumentsfromQA: action.payload,
                loading: false
            }
        case GET_BG_DETAILS:
            return {
                ...state,
                bgDetails: action.payload,
                loading: false
            }
        case BG_UPLOAD:
            return {
                ...state,
                bgUpload: action.payload,
                loading: false
            }
        case BG_UPLOAD_ERROR:
            return {
                ...state,
                bgUpload: action.payload,
                loading: false
            }

        case BG_STATUS_UPDATE:
            return {
                ...state,
                bgStatusupdate: action.payload,
                loading: false
            }
        case BG_STATUS_UPDATE_ERROR:
            return {
                ...state,
                bgStatusupdate: action.payload,
                loading: false
            }
        case BG_Request_ACTION:
            return {
                    ...state,
                    bgRequestacton: action.payload,
                    loading: false
                }
        case BG_Request_ACTION_ERROR:
            return {
                    ...state,
                    bgRequestacton: action.payload,
                    loading: false
                }    

        default: return state
    }


}

